import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

//DEPRECATED

export default (payload, hasQuantification) => {
  let rejectUrl = 'quantification/reject-vaco/'
  if (hasQuantification) {
    rejectUrl = 'quantification/reject-concepts/'
  }
  const request = Vue.$http.post(`purchase/${rejectUrl}`, payload)
  return errorHandler(request)
    .then((response) => {
      const data = response.data
      return data
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendRejectedSinister.js